import SalaryService from "../provider/Salary/SalaryService";
import { SUCCESS } from "../common/Util";
import {
	CHANGE_APP_PROPS,
	CHANGE_SALARY_PROPS,
	CHANGE_AFILIADO_PROPS
} from "./ActionConstants";

export function actionCreateSalary(values, callback) {
	return (dispatch, store) => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		asyncCreateSalary(values)
			.then(response => {
				let month = response.month;
				let year = response.year;
				let today = new Date();
				let monthAcepted = today.getMonth() + 1 - 6;
				if (month >= monthAcepted && today.getFullYear() === year) {
					let newAfiliado = store().afiliado.afiliado;
					newAfiliado.status = "ACTIVO";
					dispatch(
						{
							type: CHANGE_AFILIADO_PROPS,
							props: {
								afiliado: newAfiliado
							}
						},
						() => {}
					);
					dispatch({
						type: CHANGE_APP_PROPS,
						props: { loading: false }
					});
					callback(SUCCESS);
				} else {
					dispatch({
						type: CHANGE_APP_PROPS,
						props: { loading: false }
					});
					callback(SUCCESS);
				}
			})
			.catch(() => {
				dispatch({
					type: CHANGE_APP_PROPS,
					props: { loading: false }
				});
			});
	};
}

// function actionUploadProfilePhoto(photoUri, account, booleanoCamara) {
// 	return (dispatch, getStore) => {
// 		Util.showLoading(true);
//
// 		asyncUploadProfilePhoto(photoUri, account, booleanoCamara).then(res => {
// 			Util.showLoading(false);
//
// 			if (res.responseError) {
// 				Util.showGlobalError();
// 			} else {
// 				//OK
// 				let newAccount = {
// 					...getStore().LoginReducer.account,
// 					image: res.response
// 				};
// 				dispatch(LoginActions.changePropsLogin({ account: newAccount }));
// 			}
// 		});
// 	};
// }
async function asyncCreateSalary(values) {
	return await SalaryService.createSalary(values);
}

export function actionUpdateSalary(values, callback) {
	return (dispatch, store) => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: { loading: true }
		});
		asyncUpdateSalary(values)
			.then(response => {
				let month = response.month;
				let year = response.year;
				let today = new Date();
				let monthAcepted = today.getMonth() + 1 - 6;
				if (month >= monthAcepted && today.getFullYear() === year) {
					let newAfiliado = store().afiliado.afiliado;
					newAfiliado.status = "ACTIVO";
					dispatch(
						{
							type: CHANGE_AFILIADO_PROPS,
							props: {
								afiliado: newAfiliado
							}
						},
						() => {}
					);
					dispatch({
						type: CHANGE_APP_PROPS,
						props: { loading: false }
					});
					callback(SUCCESS);
				} else {
					dispatch({
						type: CHANGE_APP_PROPS,
						props: { loading: false }
					});
					callback(SUCCESS);
				}
			})
			.catch(() => {
				dispatch({
					type: CHANGE_APP_PROPS,
					props: { loading: false }
				});
			});
	};
}

async function asyncUpdateSalary(values) {
	return await SalaryService.updateSalary(values);
}

export function actionDeleteSalary(idSalary, callback) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		asyncDeleteSalary(idSalary).then(response => {
			dispatch({
				type: CHANGE_APP_PROPS,
				props: {
					loading: false
				}
			});
			callback(SUCCESS);
		});
	};
}

async function asyncDeleteSalary(idSalary) {
	return await SalaryService.deleteSalary(idSalary);
}

export function actionChangeSalaryProps(props) {
	return dispatch => {
		dispatch({
			type: CHANGE_SALARY_PROPS,
			props: props
		});
	};
}



// WEBPACK FOOTER //
// ./src/actions/SalaryActions.js